import React from 'react';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import { FormSection, FormLabel, FormInput, FormTextarea, FormGrid } from '../styles';

interface FormBasicInfoProps {
  formData: any;
  templateTypes: Array<{ type: string; label: string }>;
  onFormChange: (field: string, value: any) => void;
}

const FormBasicInfo: React.FC<FormBasicInfoProps> = ({ formData, templateTypes, onFormChange }) => {

  return (
    <FormSection>
      <FormGrid columns={2}>
        <div>
          <FormLabel className="required">{TEMPLATE_FORM_CONSTANTS.LABELS.TEMPLATE_NAME}</FormLabel>
          <FormInput
            type="text"
            value={formData.name}
            onChange={(e) => onFormChange('name', e.target.value)}
            placeholder={TEMPLATE_FORM_CONSTANTS.PLACEHOLDERS.TEMPLATE_NAME}
          />
        </div>

        <div>
          <FormLabel className="required">{TEMPLATE_FORM_CONSTANTS.LABELS.TEMPLATE_TYPE}</FormLabel>
          <FormInput
            as="select"
            value={formData.type}
            onChange={(e) => onFormChange('type', e.target.value)}
          >
            <option value="">{TEMPLATE_FORM_CONSTANTS.PLACEHOLDERS.TEMPLATE_TYPE}</option>
            {templateTypes?.map((type) => (
              <option key={type.type} value={type.type}>
                {type.label}
              </option>
            ))}
          </FormInput>
        </div>
      </FormGrid>

      <FormSection style={{ marginTop: '16px' }}>
        <FormLabel className="required">{TEMPLATE_FORM_CONSTANTS.LABELS.EMAIL_SUBJECT}</FormLabel>
        <FormInput
          type="text"
          value={formData.subject}
          onChange={(e) => onFormChange('subject', e.target.value)}
          placeholder={TEMPLATE_FORM_CONSTANTS.PLACEHOLDERS.EMAIL_SUBJECT}
        />
      </FormSection>

      <FormSection style={{ marginTop: '16px' }}>
        <FormLabel>{TEMPLATE_FORM_CONSTANTS.LABELS.DESCRIPTION}</FormLabel>
        <FormTextarea
          value={formData.description}
          onChange={(e) => onFormChange('description', e.target.value)}
          placeholder={TEMPLATE_FORM_CONSTANTS.PLACEHOLDERS.DESCRIPTION}
          rows={3}
          style={{ minHeight: '80px' }}
        />
      </FormSection>
    </FormSection>
  );
};

export default FormBasicInfo;
